import Chip from './chip';
import EntityHelper from '../helpers/entity';

export default class Factory {
  constructor(data) {
    EntityHelper.validateData(data);
    const {
      // eslint-disable-next-line camelcase
      id, name, factory_id, factory_name,
    } = data;

    // eslint-disable-next-line camelcase
    this.id = EntityHelper.setId(factory_id || id);
    // eslint-disable-next-line camelcase
    this.name = factory_name || name;
  }

  asChip() {
    return new Chip({
      id: this.id, title: this.name, color: 'color_e', type: Factory,
    });
  }
}
